import { createContext } from 'react';

// The Top 25 for the league on screen: {teamId: rank}. Pages for a college
// league provide it; everywhere else it's empty, so names show plain.
export const Top25Context = createContext({});

// Builds the context value from summary/rankings: college leagues only,
// top 25 only.
export function top25From(league, rankings) {
    if (!league?.settings?.useQuads || !rankings?.teams) return {};
    return Object.fromEntries(Object.entries(rankings.teams)
        .filter(([, r]) => r.poll <= 25)
        .map(([id, r]) => [id, r.poll]));
}
